import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Save } from "lucide-react";
import { handleSend } from "../../../controllers/controller.all";
import SubmitButton from "../../../components/ui/SubmitButton";


export default function InfoCreate() {
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";
    const ecoleId = user?.ecole?._id || user?.ecole;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        titre: "",
        description: "",
        lien: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        const payload = {
            ...formData,
            fichiers: [],
            ecole: ecoleId
        };
        const res = await handleSend(e, "/info", payload, setLoading, token);
        if (res) {
            navigate("/infos");
        }
    };

    return (
        <div className="relative min-h-[400px]">
            <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-sm rounded-xl">
                <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 text-center max-w-sm">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Bientôt disponible</h3>
                    <p className="text-sm text-gray-500">L'ajout d'informations n'est pas encore activé.</p>
                    <Link to="/" className="mt-4 inline-block text-indigo-600 font-medium hover:underline">Retour à l'accueil</Link>
                </div>
            </div>

            <div className="flex flex-col gap-6 max-w-2xl mx-auto opacity-40 pointer-events-none select-none">
            <div className="flex items-center gap-4">
                <Link to="/infos" className="p-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition text-gray-500">
                    <ArrowLeft className="h-5 w-5" />
                </Link>
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Nouvelle Information</h1>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden">
                <div className="p-6 space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Titre *</label>
                        <input 
                            required 
                            type="text" 
                            name="titre"
                            value={formData.titre} 
                            onChange={handleChange} 
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                            placeholder="Ex: Réunion parents-professeurs" 
                        />
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Description *</label>
                        <textarea 
                            required 
                            name="description"
                            value={formData.description} 
                            onChange={handleChange} 
                            rows={4}
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                            placeholder="Détails de l'information..." 
                        />
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Lien éventuel (ex: Meet, Zoom, Formulaire)</label>
                        <input 
                            type="url" 
                            name="lien"
                            value={formData.lien} 
                            onChange={handleChange} 
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                            placeholder="https://..." 
                        />
                    </div>
                </div>
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                    <Link to="/infos" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                        Annuler
                    </Link>
                    <SubmitButton type="submit" isSubmitting={loading} disabled={loading} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition disabled:opacity-50">
                        <Save className="h-4 w-4" />
                        Enregistrer
                    </SubmitButton>
                </div>
            </form>
            </div>
        </div>
    );
}
